import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

type Options<T, P> = {
  id: string
  fn: (args: P) => Promise<T>
  params?: P
  onDataChangeCallback?: (data: T) => void
  enabled?: boolean
}

export const useApi = <T, P>({
  id,
  params,
  fn,
  onDataChangeCallback,
  enabled = true,
}: Options<T, P>) => {
  const { data, refetch, isFetching } = useQuery({
    queryKey: params ? [id, params] : [id],
    queryFn: (args) => fn(args.queryKey[1] as P),
    enabled,
  })

  useEffect(() => {
    if (data) {
      onDataChangeCallback?.(data)
    }
  }, [data])

  return {
    data,
    isFetching,
    refetch,
  }
}
